import type { PercentThing } from "../en/percent.ts";

/** "une veste" -> "Une veste" at the head of a sentence. */
const upper = (article: string) => article.charAt(0).toUpperCase() + article.slice(1);

/** French percent prompts (ADR 0051 part 3). */
export const percentPrompts = {
    convertToDecimal: (percent: number) => `${percent} % = ______ en décimal`,
    convertToFraction: (percent: number) => `${percent} % = ______ sous forme de fraction sur 100`,
    convertToPercent: (decimalStr: string) => `${decimalStr} = ______ %`,
    findThePercent: (part: number, base: number) => `${part} représente quel pourcentage de ${base} ?`,
    // Shortened deliberately - ADR 0051 §7 part 3's Language sweep found the
    // fuller phrasing ran Percent of Change onto an extra page at 10 and 12
    // per page. Still a complete question in both languages.
    percentChangeRise: (base: number, percent: number) =>
        `Un prix de ${base} augmente de ${percent} %. Nouveau prix ?`,
    percentChangeFall: (base: number, percent: number) =>
        `Un prix de ${base} diminue de ${percent} %. Nouveau prix ?`,
    percentOf: (percent: number, base: number) => `Combien font ${percent} % de ${base} ?`,

    // Money questions (ADR 0120 §6): `$` first and a decimal point, as in
    // English, and a rate written the way the lines above write a percent.
    // Each noun carries its own article so the gender is never computed.
    retailThings: [
        { article: 'une', noun: 'chemise' },
        { article: 'une', noun: 'veste' },
        { article: 'un', noun: 'vélo' },
        { article: 'une', noun: 'lampe' },
        { article: 'un', noun: 'sac à dos' },
        { article: 'un', noun: 'jeu vidéo' },
        { article: 'une', noun: 'paire de chaussures' },
        { article: 'un', noun: 'parapluie' },
    ] as PercentThing[],
    tipThings: [
        { article: 'un', noun: 'repas' },
        { article: 'une', noun: 'coupe de cheveux' },
        { article: 'une', noun: 'course en taxi' },
        { article: 'une', noun: 'livraison de pizza' },
    ] as PercentThing[],
    salesTax: (thing: PercentThing, price: string, rate: string) =>
        `${upper(thing.article)} ${thing.noun} à ${price} avec ${rate} % de taxe. Prix total ?`,
    tip: (thing: PercentThing, bill: string, rate: string) =>
        `${upper(thing.article)} ${thing.noun} coûte ${bill}. Avec ${rate} % de pourboire, quel est le total ?`,
    discount: (thing: PercentThing, price: string, rate: string) =>
        `${upper(thing.article)} ${thing.noun} à ${price} avec ${rate} % de réduction. Prix final ?`,
    markup: (thing: PercentThing, cost: string, rate: string) =>
        `Un magasin achète ${thing.article} ${thing.noun} à ${cost} et ajoute ${rate} %. Prix de vente ?`,
    simpleInterest: (principal: string, rate: string, years: number, borrowed: boolean) =>
        borrowed
            ? `On emprunte ${principal} à ${rate} % d'intérêt simple pendant ${years} ans. Quel est l'intérêt dû ?`
            : `On place ${principal} à ${rate} % d'intérêt simple pendant ${years} ans. Quel intérêt gagne-t-on ?`,
};
